export default "__VITE_ASSET__BL8yBLR7__"